const enumString = (input: unknown, values: readonly string[]): input is string => typeof input === 'string' && values.includes(input);
const coloradoPotencyKeys = ['cbd', 'cbda', 'cbn', 'delta8thc', 'delta9thc', 'delta9thca', 'delta10thc', 'exothc', 'totalThc', 'totalCbd', 'activeThc', 'activeCbd'];
export const isColoradoPotencyMappingSource = (input: unknown): boolean =>
  input === 'Colorado.LabTestTypeCatalog' || input === 'Colorado.TestingCO.LabTestTypeCatalog';
const mappingFields = ['analyteKey', 'measurementBasis', 'aggregateKind', 'mappingStatus', 'mappingSource'];
export function validColoradoPotencyMapping(input: Record<string, unknown>): boolean {
  // Older and non-Colorado responses carry no catalog mapping.
  if (mappingFields.every(key => input[key] == null)) return true;
  if (!enumString(input.mappingStatus, ['mapped', 'unitUnavailable', 'identityMismatch', 'unmapped'])) return false;
  if (input.mappingStatus === 'identityMismatch' || input.mappingStatus === 'unmapped') {
    return input.analyteKey === null && input.measurementBasis === null && input.aggregateKind === null
      && input.mappingSource === null;
  }
  if (!isColoradoPotencyMappingSource(input.mappingSource)) return false;
  if (!enumString(input.analyteKey, coloradoPotencyKeys)) return false;
  const aggregate = ['activeThc', 'activeCbd'].includes(input.analyteKey) ? 'active'
    : ['totalThc', 'totalCbd'].includes(input.analyteKey) ? 'total' : null;
  if (input.aggregateKind !== aggregate) return false;
  if (input.mappingStatus === 'unitUnavailable') return aggregate === null && input.measurementBasis === null && input.unit === null;
  if (aggregate === 'active' && input.measurementBasis === 'percent') return false;
  const productionCbd = input.analyteKey === 'cbd' && input.mappingSource === 'Colorado.LabTestTypeCatalog';
  if ((aggregate === 'total' || productionCbd) && input.measurementBasis !== 'percent') return false;
  const units = { percent: '%', perUnit: 'mg/unit', perServing: 'mg/serving' };
  return enumString(input.measurementBasis, Object.keys(units))
    && input.unit === units[input.measurementBasis as keyof typeof units];
}

export function hasMatchingColoradoPotencyMapping(input: Record<string, unknown>, identity: unknown): boolean {
  return Array.isArray(identity) && identity[0] === 'cannabinoid' && identity[1] === input.analyteKey
    && input.mappingStatus === 'mapped' && isColoradoPotencyMappingSource(input.mappingSource)
    && validColoradoPotencyMapping(input);
}
